module.exports = __webpack_public_path__ + "img/banner1.f5e8f44a.png";